import { TenantUuid } from '../hooks/useTheme'

export interface IApplicantData {
  clientUuid?: TenantUuid
  personId?: string
  origin: string
  traversalUuid?: string
  loanLeadUuid?: string
  customerUuid?: string
  applicationUuid?: string
  firstName?: string
  lastName?: string
}

export enum FTSWidgetActionTypes {
  FTS_WIDGET_FIELD_CHANGE = 'FTS_WIDGET_FIELD_CHANGE',
  SET_FTS_WIDGET_TRANSACTION_DATA = 'SET_FTS_WIDGET_TRANSACTION_DATA',
}

interface IFTSWidgetFieldChange {
  type: FTSWidgetActionTypes.FTS_WIDGET_FIELD_CHANGE
  payload: {
    isFetching?: boolean
    wizardKey?: string
    transactionId?: string
    requestError?: Error
  }
}

interface IFTSWidgetSetTransactionData {
  type: FTSWidgetActionTypes.SET_FTS_WIDGET_TRANSACTION_DATA
  payload: IApplicantData
}

export type FTSWidgetActions =
  | IFTSWidgetFieldChange
  | IFTSWidgetSetTransactionData
